import styled, { css } from "styled-components";
import { colors, sizes } from "@sonder/ui/source/styled/theme";

interface LayoutProps {
  sidebar?: "collapsed" | "expanded";
  sidepanel?: "collapsed" | "expanded";
  header?: "collapsed" | "expanded";
}
const getHeaderRows = (props: LayoutProps) => {
  if (props.header === "collapsed") return "0 auto";

  return "auto 1fr";
};
const getHeaderAreas = (props: LayoutProps) => {
  if (props.sidebar === "expanded") return "sidebar sidebar header header";

  return "sidebar header header header";
};
const getContentAreas = (props: LayoutProps) => {
  if (props.sidebar === "expanded" && props.sidepanel === "expanded")
    return "sidebar sidebar content sidepanel";

  if (props.sidebar === "expanded") return "sidebar sidebar content content";

  if (props.sidepanel === "expanded")
    return "sidebar content content sidepanel";

  return "sidebar content content content";
};

const responsiveLayoutQuery = css`
  @media screen and (max-width: ${sizes.minBreakpoint}) {
    grid-template-columns: auto auto auto;
  }
`;

const responsiveLayoutQueryExpanded = css`
  @media screen and (max-width: ${sizes.minBreakpoint}) {
    grid-template-columns: 0 0 auto;
  }
`;

const getResponsizeLayoutQuery = (props: LayoutProps) => {
  return props.sidepanel === "expanded"
    ? responsiveLayoutQueryExpanded
    : responsiveLayoutQuery;
};
const getResponsiveHeaderAreas = (props: LayoutProps) => {
  if (props.sidebar === "expanded") return "sidebar header header";

  return "header header header";
};
const getResponsiveContentAreas = (props: LayoutProps) => {
  if (props.sidebar === "expanded" && props.sidepanel === "expanded")
    return "sidebar content sidepanel";

  if (props.sidebar === "expanded") return "sidebar content content";

  if (props.sidepanel === "expanded") return "content content sidepanel";

  return "content content content";
};

export const Layout = styled.div<LayoutProps>`
  background: ${colors.grayF};
  display: grid;
  height: 100%;
  width: 100%;

  grid-template-columns: ${sizes.sidebarWidth} 11rem 1fr ${props =>
      props.sidepanel === "expanded" ? sizes.sidepanelWidth : "auto"};
  grid-template-rows: ${getHeaderRows};
  grid-template-areas: "${getHeaderAreas}" "${getContentAreas}";

  ${getResponsizeLayoutQuery}
  @media screen and (max-width: ${sizes.minBreakpoint}) {
    grid-template-areas: "${getResponsiveHeaderAreas}" "${getResponsiveContentAreas}";
  }
`;
